import * as Sentry from '@sentry/astro';

Sentry.init({
  dsn: 'https://b1fdeec5e28b1206e6e19633b0fc9e4e@o4507994176356352.ingest.us.sentry.io/4507994178191360',
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  tracesSampleRate: 0.2,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});
